import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
export var GET_CUSTOMER_DETAILS = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query accountChipQuery {\n        # eslint-disable-next-line @graphql-eslint/require-id-when-available\n        customer {\n            firstname\n        }\n    }\n"])));